import { CeruleanButton } from 'components/Button'
import Column from 'components/Column'
import Field from 'components/Field'
import Input from 'components/Input'
import InputContainer from 'components/InputContainer'
import formName from 'constants/formName'
import { selectors } from 'data'
import messages from 'lang'
import isEqual from 'lodash/isEqual'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { connect, ConnectedProps } from 'react-redux'
import { getFormValues, isValid } from 'redux-form'
import { validator } from 'utils'

import Container from '../Modal/Container'

type PropsType = WrappedComponentProps & ConnectedProps<typeof connector>

class VerifyTotp extends React.Component<PropsType> {
  shouldComponentUpdate = (nextProps: PropsType) => !isEqual(this.props.values, nextProps.values)

  render() {
    const { hasTwoFactorSetup, intl, valid } = this.props
    return (
      <Container
        sub={intl.formatMessage(messages.sub_title_verify_2fa)}
        title={intl.formatMessage(messages.title_verify_2fa)}
      >
        <Column>
          <InputContainer>
            <Field
              component={Input}
              e2e='twoFactorInput'
              label={intl.formatMessage(messages.label_verif_code)}
              name='twoFactorCode'
              placeholder={intl.formatMessage(messages.placeholder_signin_verif)}
              validate={[validator.required]}
            />
          </InputContainer>

          {!hasTwoFactorSetup && (
            <InputContainer>
              <Field
                component={Input}
                e2e='twoFactorEmailCode'
                label={intl.formatMessage(messages.verify_2fa_email_code_label)}
                name='emailCode'
                placeholder={intl.formatMessage(messages.placeholder_verify_2fa_email_code_label)}
                validate={[validator.required]}
              />
            </InputContainer>
          )}

          <CeruleanButton disabled={!valid} e2e='nextButton' type='submit'>
            {intl.formatMessage(messages.button_verify)}
          </CeruleanButton>
        </Column>
      </Container>
    )
  }
}

const mapStateToProps = (state) => ({
  hasTwoFactorSetup: (selectors.auth.getTwoFactorStatus(state)?.length ?? 0) > 0,
  valid: isValid(formName.TWO_FACTOR)(state),
  values: getFormValues(formName.TWO_FACTOR)(state)
})

const connector = connect(mapStateToProps)

export default connector(injectIntl(VerifyTotp))
